import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { isObject, isSet } from "../../utils/commonUtils";
import FormInputs from "../../components/UI/FormInputs";
import { useToast } from "../../context/ToaxtContext";
import WithRoutify from "../../hoc/WithRoutify";
import withReduxState from "../../hoc/wReduxState";
import Buttons from "../../components/UI/Buttons";
import Icd10Service from "../../services/Icd10Service";
import VideoConfigService from "../../services/VideoConfigService";

const AddVideoConfig = (props) => {
  const [validation, setValidation] = useState({});
  const [formData, setFormData] = useState({});
  const {
    isOpen,
    addFormHandler,
    fetchList,
    modelTitle,
    activeEditId,
    Toast,
    Loader,
  } = props;
  useEffect(() => {
    if (activeEditId) {
      //fetch
      VideoConfigService.getVideoConfigbyId(activeEditId).then((response) => {
        setFormData({ ...formData, ...response });
      });
    }
  }, []);

  const screenList = [
    { label: "profile", value: "profile" },
    { label: "Authentication", value: "authentication" },
    { label: "company", value: "company" },
    

    { label: "Dashboard", value: "dashboard" },
    { label: "Appointments", value: "appointments" },
    { label: "White Board", value: "white-board" },
    { label: "Visits", value: "visits" },
    { label: "Visit Details", value: "visits/visit-details" },
    { label: "EMR Visit Details", value: "visits/emr-details" },
    { label: "Labs", value: "labs" },
    { label: "Vaccines", value: "result/vaccine" },
    { label: "Result Physicals & Drug Screens", value: "result/physical-drug-screens" },
    { label: "Patients", value: "employee" },
    {label: "Patient Visit History", value: "employee/visit-history"},
    { label: "Reports", value: "reports" },
    { label: "Incident", value: "incident" },

    { label: "Users", value: "users" },
    { label: "Role & Permissions", value: "roles" },
    { label: "Clinics", value: "clinics" },
    { label: "Providers", value: "providers" },
    { label: "Laboratory", value: "laboratory" },
    { label: "Clinic Department", value: "clincs-department" },
    { label: "Insurance", value: "insurance" },
    { label: "Work Comp Insurance", value: "workcomp-insurance" },
    { label: "Company Divisions", value: "division" },
    { label: "Lookup", value: "lookup" },
    { label: "Basic Physical", value: "basic-physical" },
    { label: "Activities", value: "activities" },
    { label: "Compliance Monitor", value: "compliance-monitor" },
    { label: "Contract Pricing", value: "contract/pricing" },
    { label: "company phsyical", value: "company/physical" },
    { label: "CPT Code", value: "cpt-code" },
    { label: "ICD-10 Code", value: "icd10-code" },
    { label: "Intake Paperwork", value: "intake-paperwork" },
    { label: "Vaccine Administration", value: "vaccine-administration" },
    { label: "SFTP Configuration", value: "configure" },
    { label: "CSV Imports", value: "csv-import" },
    { label: "Failed EZ-Reader", value: "failed-ez-reader" },
    { label: "Notification Log", value: "notification-log" },
    { label: "HL7 Log", value: "hl7/log" },
    { label: "Audit Log", value: "audit-log" },
    { label: "EMR Fields setup", value: "emr" },
    { label: "Random Generator", value: "random-generator" },
    { label: "State Forms Configuration", value: "forms-configuration" },
    { label: "Lab Pannel Configuration", value: "lab-pannel-configuration" },
    { label: "Lab Pannel Manual Import", value: "lab-pannel-import" },
    { label: "Tutorial Video configure", value: "video-configure" }
  ];
  
    
    

  const inputFields = [
     {
      type: "SelectSearchList",
      label: "Screen List",
      placeholder: "Screens",
      className: "form-control form-control-solid",
      name: "screen_route",
      options: screenList,
      value: formData.screen_route,
      required: true,
    },
    {
      type: "TextInput",
      label: "Video Link",
      placeholder: "Video Link",
      className: "form-control form-control-solid",
      name: "video_url",
      required: true,
    },
    {
      type: "TextArea",
      label: "Description",
      placeholder: "Description",
      className: "form-control form-control-solid",
      name: "description",
      value: formData.description,
    },
   
  ];
  const changeHandler = (val, fieldName, e) => {
    setFormData({
      ...formData,
      [fieldName]: val,
    });
    setValidation({ ...validation, [fieldName]: "" });
  };
  const formSubmitHandler = async () => {
    const payload = {
      screen_route: formData.screen_route,
      description: formData.description,
      video_url: formData.video_url,
    };
    let updateValidation = { ...validation };
    let data;
    if (activeEditId) {
      data = await VideoConfigService.updateVideoConfigById(activeEditId, payload);
    } else {
      data = await VideoConfigService.saveVideoConfig(payload);
    }
    if (data.status && data.status == "ERROR") {
      if (isObject(data.data)) {
        for (let key in data.data) {
          updateValidation = {
            ...updateValidation,
            [key]: data.data[key].join(","),
          };
        }
      } else {
        Toast.error(data.data);
      }
      if (Object.keys(updateValidation).length > 0) {
        setValidation(updateValidation);
      }
    } else {
      fetchList();
      addFormHandler();
      let message = `Video Configure ${activeEditId ? "Update" : "Added"} Sucessfully`;
      Toast.success(message);
    }
  };
  return (
    <>
      <Modal
        show={isOpen}
        onHide={addFormHandler}
        size="lg"
        dialogClassName="hResponsive"
        contentClassName="h-100"
        backdrop="static"
        keyboard={false}
      >
        <div className="sh_modalBox">
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 className="font-weight-bold text-lg mb-0">{modelTitle}</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {inputFields &&
                inputFields.map((field, index) => (
                  <div className={`col-12  `} key={index}>
                    <div className="form-group">
                      <label className="text-gray-900 text-md opacity-75">
                        {" "}
                        {field.label}{" "}
                      </label>
                      <FormInputs
                        {...field}
                        changeHandler={(value, e) =>
                          changeHandler(value, field.name, e)
                        }
                        value={formData[field.name]}
                      />
                      {isSet(validation[field.name], "") !== "" ? (
                        <span className="text-danger m-1">
                          {isSet(validation[field.name], "")}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </Modal.Body>

            <Modal.Footer className="d-flex justify-content-center">
              <Buttons
                clickHandler={() => formSubmitHandler()}
                className="btn btn-primary"
                acl={"any"}
                label={activeEditId ? "Update" : "Save"}
              />
              {/*
            <Buttons
                clickHandler={() => addFormHandler()}
                className="btn btn-outline-secondary rounded-pill"
                acl={"any"}
                label={"Cancel"}
              />
              */}
            </Modal.Footer>
          </div>
        </Modal>
      </>
    );
  };
  export default withReduxState(WithRoutify(AddVideoConfig));
